export class Message {
  id: string = '';
  subject: string = '';
  message_from: string = '';
  message_from_institution_name: string = '';
  content: string = '';
  business_entity_name?: string;
  created_at?: Date;
  isOpen: boolean = false;
  is_seen: boolean = false;
  marked: boolean = false;
}
